import { MDBContainer } from "mdbreact";
import styled, { css, keyframes } from "styled-components";

export const PageContainer = styled.div`
  background: rgb(128, 65, 153);
  height: 100vh;
  width: 100%;
  padding: 5% 15px;
`;
